import { supabase } from "./supabase.js";

// Aprovar/rejeitar chama /api/quest-action (Cloudflare Pages Function) em vez do
// N8N diretamente — evita CORS do browser para o N8N em Fly.io e permite capturar
// o status HTTP real da chamada ao webhook para o retry descrito na spec (ver
// design.md decisão 4). A Function valida o Bearer token da sessão do Fundador,
// grava em human_approvals usando esse token (RLS founder), e só then dispara o
// webhook N8N server-to-server.
async function callQuestAction(body) {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session) throw new Error("Sessão expirada — faça login novamente.");

  const response = await fetch("/api/quest-action", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.access_token}`,
    },
    body: JSON.stringify(body),
  });

  const result = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(result.error ?? `Falha na ação (HTTP ${response.status})`);
  }

  return result;
}

export async function approveQuest(questId) {
  return callQuestAction({ questId, action: "approve" });
}

export async function rejectQuest(questId, reason) {
  if (!reason || !reason.trim()) {
    throw new Error("Motivo é obrigatório para rejeitar uma quest.");
  }
  return callQuestAction({ questId, action: "reject", reason: reason.trim() });
}
